import Vue from 'vue'
import {Utils} from 'hasta-la-vista-ui-core'
import {MovieService, MovieMetaService, AuthService, OrderService,PreviewService, EcomTrackingService, RegionService} from 'hasta-la-vista-middleware-api/service'
import objectFitImages from 'object-fit-images';
import moment from 'moment'
import MetaData from  '../../../mixins/meta-data.js'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

const ecomTrackedMovies = []

export default {
    name: 'home',

    mixins: [MetaData],

    data () {
        return {
            loading: true,
            previewMode:false,
            top: 0,
            // Feature carousel temp data
            featuredData: null,
            form_data: {
                count: 0,
                place_query: null,
                keyword: null,
                selected_cinema: null,
                genres: null,
                cinema_types: [],
                filter_group: {
                    genres: null,
                    cinema_types: null,
                },
                selected_time_range: null,
                doInitialSearch: false,
            },
            filter: {
                filter_group: {},
                keyword: null,
                place_query: null,
                selected_cinema: {
                    id: null,
                    latitude: null,
                    longitude: null,
                    name: null,
                    original_name: null,
                },
                experiences: null,
                genres: null,
                time_range: null,
            },
            // Movie data
            movies: null,
            availableCinemas: [],
            activeMovie: null,
            movieSummary: null,
            bottomOffset: null,
            tabNowShowing: null,
            tabComingSoon: null,
            predictiveText: [],
            // Dialogs
            activeDialog: false,
            dialogData: null,
            selected_cinema_id: null,
            selected_experiences:[],
            selected_cinema: null,
            selected_time_range: null,
            toastOptions: null,
            doSearch: true,
            skclubAlert: false,
            leftAd: null,
            rightAd: null,
            featureCarouselHeight: 0,
            user: null,
            showLoadMoreNowShowing: this.$breakpoints.xs ? true : false,
            showLoadMoreComingSoon: this.$breakpoints.xs ? true : false,
            loadMoreLimitNowShowing: 16,
            loadMoreLimitComingSoon: 16,
            loadMoreIncrement: 16,
            isVisible: false,
            scrollY: 0,
            visibleMovies: [],
            cinemasByRegion: [],
            timeRanges: [],
            timeRangeData: [],
            cinemaTypes: [],
            movieGenres: [],
            filterOptions: null,
            searchResultCount: null,
            cinemasNearby: null,
            summary_data: {
                types: null,
                time: null,
            },
            summary_types: null,
            summary_time: null,
            summary_cinema_slug: null,
            onNouveau: false,
            regions: {},
            cinemaTypeGroups: [],
            movieMeta: null,
            type_groups: null,
            result_cinemas: null,
            countNS: 0,
            countCS: 0,
            currentTimeStamp: null,
            foo: "no",
            injected_movies: "{data:'none'}",
            injected_meta: "{data:'none'}",
            injected_regions: "{data:'none'}",
            injected_cinemas: "{data:'none'}",
            prerender: false,
            googleAds: process.env.GOOGLE_AD_ENV == 'production'
                ? {
                    classic: {
                        left: '/40862963/SK-HomeP-Wallpaper-Right',
                        right: '/40862963/SK-HomeP-Wallpaper-Left',
                        top: '/40862963/SK-HomeP-320x50',
                        topLg: '/40862963/SK-HomeP-728x90'
                    },
                    nouveau: {
                        left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                        right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                        top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                        topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                    }
                }
                : {
                    classic: {
                        left: '/40862963/SK-HomeP-Wallpaper-Right',
                        right: '/40862963/SK-HomeP-Wallpaper-Left',
                        top: '/40862963/SK-HomeP-320x50',
                        topLg: '/40862963/SK-HomeP-728x90'
                    },
                    nouveau: {
                        left: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Left',
                        right: '/40862963/SK-EventsAndExperiences-Nouveau-Wallpaper-Right',
                        top: '/40862963/SK-EventsAndExperiences-Nouveau-320x50',
                        topLg: '/40862963/SK-EventsAndExperiences-Nouveau-728x90'
                    }
                },
        }
    },

    methods: {
        visibilityChanged(isVisible, entry, movie) {
            if(isVisible && !ecomTrackedMovies.includes(movie.id)) {
                var position = 0;
                if(this.tabNowShowing && !movie.coming_soon) {
                    for(let n in this.movies.now_showing) {
                        if(movie.id == this.movies.now_showing[n]) {
                            position = (n+1);
                        }
                    }
                }

                if(this.tabComingSoon && movie.coming_soon) {
                    for(let n in this.movies.coming_soon) {
                        if(movie.id == this.movies.coming_soon[n]) {
                            position = (n+1);
                        }
                    }
                }

                EcomTrackingService.doDataLayerImpression(movie, position);
                ecomTrackedMovies.push(movie.id)
            }
        },

        showMovieDetail(movie, clickedThumb) {
            if (this.activeMovie == movie) {
                this.activeMovie = null
            } else {
                this.activeMovie = movie
            }

            if(this.activeMovie != null) {
                EcomTrackingService.doDataLayerProductClick(this.activeMovie, this.movies, this.tabNowShowing, this.tabComingSoon)
            }

            Utils.debounce(() => {
                // console.log({clickedThumb})
                let headeHeight = this.$breakpoints.xs ? 25 : 100
                window.scroll({top: (clickedThumb.offsetTop + clickedThumb.offsetHeight) - headeHeight, left: 0, behavior: 'smooth'})

                Vue.nextTick(() => {
                    if (!this.movieSummary) {
                        this.movieSummary = this.$refs.movie_summary
                        let sumHeight = this.movieSummary.$el.offsetHeight + 35
                        this.bottomOffset = sumHeight + 'px'
                    } else {
                        this.movieSummary = null
                        if (this.$refs.movie_summary) {
                            this.movieSummary = this.$refs.movie_summary
                            let sumHeight = this.movieSummary.$el.offsetHeight + 35
                            this.bottomOffset = sumHeight + 'px'
                        }
                    }

                    this.top = clickedThumb.offsetTop + clickedThumb.offsetHeight + 35

                })
            }, 1)()

        },

        openVideoDialog(feature) {
            this.activeDialog = true
            this.dialogData = feature
        },

        checkNouveauGenres(form_data, url) {
            let goToClassic = false
            let goToNouveau = false
            let hasNouveau = false
            if(this.onNouveau) {
                if(form_data.cinema_types == undefined || form_data.cinema_types == null) {
                    goToClassic = true
                } else {
                    if(form_data.cinema_types.length == 0) {
                        goToClassic = true
                    } else {
                        
                        for(let g in form_data.cinema_types) {
                            if(form_data.cinema_types[g].name == "Nouveau") {
                                hasNouveau = true
                                goToClassic = true
                            }
                        }
                    }
                }
                // console.log("hasNouveau", hasNouveau, "goToClassic", goToClassic, "onNouveau", this.onNouveau)
                if(goToClassic && !hasNouveau) {
                    window.location.href=url
                }
            } else {
                if(form_data.cinema_types == undefined || form_data.cinema_types == null) {
                    goToNouveau = false
                } else {
                    if(form_data.cinema_types.length == 0) {
                        goToNouveau = false
                    } else {
                        
                        for(let g in form_data.cinema_types) {
                            if(form_data.cinema_types[g].name == "Nouveau" && !this.onNouveau) {
                                hasNouveau = true
                                goToNouveau = true
                            }
                        }
                    }
                }
                // console.log("hasNouveau", hasNouveau, "goToNouveau", goToNouveau, "onNouveau", this.onNouveau)
                if(goToNouveau && hasNouveau && !this.onNouveau) {
                    window.location.href=url
                }
            }
        },


        getFilteredMovies(filter) {
            var criteria = {
                cinema_id: false,
                types: false,
                genres: false,
                time_range: false,
                title: false,
            }

            if(this.form_data.selected_cinema != undefined && this.form_data.selected_cinema.id > 0) { 
                criteria.cinema_id = this.form_data.selected_cinema.id
            }
            let url = this.setUrlFromFilter(this.form_data);
            let checkNouveauGenres = this.checkNouveauGenres(this.form_data, url)

            let types = this.filterTypes(this.form_data.cinema_types)
            let genres = this.filterGenres(this.form_data.genres)
            let time = this.filterTime(this.form_data.selected_time_range)
            
            criteria.types = types
            criteria.genres = genres
            criteria.time_range = time
            criteria.title = this.form_data.keyword
            // console.log("criteria", criteria)
            MovieService.filter(criteria).then((result) => {
                // console.log("result", result)
                if(result) {
                    // console.log("result", result)
                    if(result.cinemas && result.cinemas.length > 0 && !criteria.cinema_id && (criteria.types || criteria.genres || criteria.time_range || criteria.title)) {
                        // console.log("cinemas", result.cinemas)
                        this.result_cinemas = result.cinemas
                        this.setCinemasByRegion(this.regions, this.result_cinemas);
                    } else {
                        // console.log("cinemas", result.cinemas)
                        this.setCinemasByRegion(this.regions, null)
                    }
                    // console.log("result.types", result.types)
                    if(result.types && !criteria.types && (criteria.cinema_id || criteria.genres || criteria.time_range || criteria.title)) {
                        // console.log("types", result.types, this.type_groups)
                        this.setTypeOptions(this.type_groups, result.types);
                    } else {
                        this.setTypeOptions(this.type_groups, null)
                    }

                    if(result.times && !criteria.time_range && (criteria.cinema_id || criteria.genres || criteria.types || criteria.title)) {
                        // console.log("times", result.times)
                        this.setTimeOptions(result.times)
                    } else {
                        this.setTimeOptions(null)
                    }

                    if(result.genres) {
                        if(this.movieMeta != undefined && this.movieMeta != null && !criteria.genres && (criteria.cinema_id || criteria.genres || criteria.time_range || criteria.types)) {
                            // console.log("genres", result.genres)
                            this.setGenreOptions(this.movieMeta.genres, result.genres)
                        } else {
                            this.setGenreOptions(this.movieMeta.genres, null)
                        }
                    }

                    if(result.movies) {
                        this.searchResultCount = Object.keys(result.movies).length
                        // console.log("movies",result.movies)
                        Promise.resolve(MovieService.moviesByRelease(result.movies)).then((movies) => {
                            // console.log("movies",movies)
                            this.movies = movies
                            this.countNS = 0;
                            this.countCS = 0;
                            for(let ns in this.movies.now_showing) {
                                if(this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && (typeof this.movies.now_showing[ns] == "object")) {
                                    this.countNS++
                                }
                            }

                            for(let ns in this.movies.coming_soon) {
                                if(this.movies.coming_soon[ns] != null && this.movies.coming_soon[ns] != undefined && (typeof this.movies.coming_soon[ns] == "object")) {
                                    this.countCS++
                                }
                            }
                            this.activeMovie = null;
                        })    
                    }
                }
            });
        },

        filterTime(selected_time_range) {
            let time_range = {}
            if(selected_time_range != undefined && selected_time_range != null) {
                for(let t in selected_time_range.config_ranges) {
                    if(selected_time_range.config_ranges[t] != undefined && selected_time_range.config_ranges[t] != null) {
                        if(selected_time_range.config_ranges[t] != undefined && selected_time_range.config_ranges[t] != null && typeof selected_time_range.config_ranges[t] == "string") {
                            let range = selected_time_range.config_ranges[t];
                            time_range[range] = range;
                        }
                    }
                }
            }
            if(!Object.keys(time_range).length) {
                time_range = null
            }
            return time_range
        },

        filterTypes(selected_types) {
            var types = {}
            for(let st in selected_types) {
                // console.log(selected_types[st])
                for(let t in selected_types[st].types) {
                    // console.log(selected_types[st].types)
                    if(selected_types[st].types[t] != undefined) {
                        if(selected_types[st].types[t].name != undefined && selected_types[st].types[t].name != null) {
                            let type = selected_types[st].types[t].name.trim()
                            types[type] = type
                        }
                    }
                }
            }

            if(!Object.keys(types).length > 0) {
                types = false
            }

            return types
        },

        filterGenres(selected_genres) {
            let genres = {}
            for(let g in selected_genres) {
                if(selected_genres[g] != undefined && selected_genres[g] != null) {
                    if(selected_genres[g].id != undefined && selected_genres[g].id != null) {
                        let genre = selected_genres[g].id
                        genres[genre] = genre
                    }
                }
            }
            if(!Object.keys(genres).length) {
                genres = null
            }

            return genres
        },

        scrollDown() {
            window.scroll({top: this.$refs.search_filter.$el.offsetTop / 1.2, left: 0, behavior: 'smooth'})
        },

        showAlerts() {
            if (window.scrollY > document.body.offsetHeight / 3) {
                let currentDate = moment().format('YYYYMMDD')
                let newDate = moment(currentDate).add('1', 'month')
                if (localStorage.getItem('skclubAlert') == null) {
                    this.skclubAlert = true
                    localStorage.setItem('skclubAlert', newDate)
                }
            }
        },

        setCinemasByRegion(raw_regions, filter_cinemas = null) {
            var allowedRegions = []

            if(raw_regions && raw_regions != null && raw_regions != undefined && !this.allowedRegions) {

                if(typeof raw_regions == "object" && Object.keys(raw_regions).length) {

                    allowedRegions = raw_regions.map((r)=> {
                        let cinemas = r.cinemas.filter((c)=>~this.availableCinemas.indexOf(c.id.toString()) || this.availableCinemas.length == 0);
                        return {
                            id: r.id,
                            name: r.name,
                            cinemas
                        };
                    }).filter((r)=>r.cinemas.length > 0)
                }
            }

            // console.log("home cinemasNearby",this.cinemasNearby)

            let regions = []
            if(filter_cinemas != null) {
                if(Object.keys(filter_cinemas).length > 0) {
                    let sorted_filter_cineams = null
                    let sorted_regions = null
                    filter_cinemas = MovieService.filterCinemasToRegionModel(filter_cinemas, allowedRegions)
                    sorted_filter_cineams = MovieService.sortfilteredCinemasByDistance(filter_cinemas)
                    // console.log("sorted_filter_cineams", sorted_filter_cineams)
                    sorted_regions = MovieService.sortRegionsByDistance(allowedRegions)
                    // console.log("sorted_regions", sorted_regions)
                    if(sorted_filter_cineams != null && sorted_filter_cineams != undefined) {
                        regions = [{name: 'Cinemas', cinemas: sorted_filter_cineams}]
                    }
                    
                    if(this.cinemasNearby != null) {
                        regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)   
                    }
                }
            } else {
                regions = allowedRegions
                if(this.cinemasNearby != null) {
                    regions = [{name: 'Cinemas Nearby', cinemas: this.cinemasNearby}].concat(regions)   
                }
            }

            this.cinemasByRegion = regions
        },

        setTypeGroups(types) {
            if(types && types != undefined && types != null) {
                if(this.type_groups == null) {
                    return Promise.resolve(MovieService.generateExperienceGroups(types)).then((groups) => {
                        this.type_groups = groups
                        return groups
                    })
                } else {
                    return this.type_groups
                }
            }
        },

        setTypeOptions(types, filter_types) {
            // console.log("setTypeOptions", types, filter_types)
            if(types && types != undefined && types != null) {
                Promise.resolve(this.setTypeGroups(types)).then((type_groups) => {
                    // console.log("type_groups", type_groups)
                    if(this.type_groups != null) {
                        var typeData = {}
                        if(this.type_groups && this.type_groups != undefined && this.type_groups != null) {
                            typeData = [{label: 'Cinema Types', items: type_groups}]

                            if(filter_types) {
                                Promise.resolve(MovieService.filterExperienceGroups(this.type_groups, filter_types)).then((groups) => {
                                    // console.log("groups",groups)
                                    if(groups.available != null && groups.available != undefined) {
                                        typeData = [{label: 'Cinema Types', items: groups.available}]
                                    } else {
                                        typeData = [{label: 'Cinema Types', items: groups.other}]
                                    }
                                    
                                    this.cinemaTypes = typeData
                                })
                            } else {
                                this.cinemaTypes = typeData
                            }
                        }

                        
                    }
                })
            }
        },

        setTimeOptions(times) {
            if(this.timeRangeData && this.timeRangeData != undefined && this.timeRangeData != null) {
                let data = this.timeRangeData.items
                let availableTimes = []
                if(times != undefined && times != null) {
                    for(let d in data) {
                        if(data[d] != undefined && data[d] != null) {
                            for(let t in times) {
                                if(times[t] != undefined && times[t] != null) {
                                    for(let c in data[d].config_ranges) {
                                        if(data[d].config_ranges[c] != undefined && data[d].config_ranges[c] != null) {
                                            if(times[t].includes(data[d].config_ranges[c])) {
                                                let exists = false

                                                if(availableTimes.length > 0) {
                                                    for(let at in availableTimes) {
                                                        if(availableTimes[at].id == data[d].id) {
                                                            exists = true
                                                        }
                                                    }
                                                }

                                                if(!exists) {
                                                    availableTimes.push(data[d])
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                let result = {
                    available: availableTimes,
                    other: [],
                }

                for(let d in data) {
                    let inAvailable = false
                    if(data[d] != undefined && data[d] != null) {
                        for(let t in availableTimes) {
                            if(availableTimes[t] != undefined && availableTimes[t] != null) {
                                if(data[d].id == availableTimes[t].id) {
                                    inAvailable = true
                                }
                            }
                        }
                    }

                    if(!inAvailable) {
                        result.other.push(data[d])
                    }
                }

                // console.log("show times",result)

                if(result.available != null && result.available != undefined) {
                    if(result.available.length > 0) {
                        this.timeRanges = [{name: "Show times", items: result.available}]
                    } else {
                        this.timeRanges = [{name: "Show times", items: result.other}]    
                    }
                } else {
                    this.timeRanges = [{name: "Show times", items: result.other}]
                }

                
                return result
            }
        },

        setGenreOptions(genres, filter_genres) {
            var genreData = {}

            let availableGenres = []
            let otherGenres = []

            if(genres && genres != undefined && genres != null) {
                if(filter_genres && filter_genres != null && filter_genres != undefined) {
                    for(let fg in filter_genres) {
                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                if(filter_genres[genres[g].id] != null && filter_genres[genres[g].id] != undefined) {
                                    let exists = false

                                    for(let ag in availableGenres) {
                                        if(availableGenres[ag] != undefined && availableGenres[ag] != null) {
                                            if(availableGenres[ag].id == genres[g].id) {
                                                exists = true
                                            }
                                        }
                                    }

                                    if(!exists) {
                                        availableGenres.push(genres[g])
                                    }
                                }
                            }
                        }
                    }

                    for(let g in genres) {
                        let inAvailable = false
                        if(genres[g] != undefined && genres[g] != null) {
                            for(let ag in availableGenres) {
                                if(availableGenres[ag] != undefined && availableGenres[ag] != null) {
                                    if(availableGenres[ag].id == genres[g].id) {
                                        inAvailable = true
                                    }
                                }
                            }
                        }

                        if(!inAvailable) {
                            let exists = false
                            for(let og in otherGenres) {
                                if(otherGenres[og] != undefined && otherGenres[og] != null) {
                                    if(otherGenres[og].id == genres[g].id) {
                                        exists = true
                                    }
                                }
                            }

                            if(!exists) {
                                otherGenres.push(genres[g])
                            }
                        }
                    }
                    if(availableGenres != null && availableGenres != undefined) {
                        genreData = [{label: "Genres", items: availableGenres}]
                    } else {
                        genreData = [{label: "Genres", items: otherGenres}]
                    }
                    
                } else {
                    genreData = [{label: 'Genres', items: genres}]
                }
            }

            this.movieGenres = genreData
        },

        setUrlFromFilter(criteria) {
            let url = "";
            let summary_data = {
                    types: null,
                    time: null,
                    cinema_slug: null,
                }
            if(criteria && criteria != undefined && criteria != null) {
                
                if(criteria.selected_cinema != undefined && criteria.selected_cinema != null) {
                    if(criteria.selected_cinema.slug != undefined && criteria.selected_cinema.slug != null) {
                        url = url + "/cinema/" + criteria.selected_cinema.slug
                        this.summary_cinema_slug = this.form_data.selected_cinema.slug;
                    }
                }

                if(criteria.cinema_types != undefined && criteria.cinema_types != null) {
                    if(criteria.cinema_types.length > 0) {
                        let types = criteria.cinema_types
                        let typeDict = []
                        for(let t in types) {
                            if(types[t] != undefined && types[t] != null) {
                                typeDict.push(types[t].name)
                            }
                        }

                        if(typeDict.length > 0) {
                            let type_string = typeDict.join()

                            url = url + "/type/" + type_string
                            this.summary_types = type_string
                        }
                        
                    }
                }

                if(criteria.genres && criteria.genres != undefined && criteria.genres != null) {
                    if(criteria.genres.length > 0) {
                        let genres = criteria.genres
                        let genreDict = []
                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                genreDict.push(genres[g].name)
                            }
                        }

                        if(genreDict.length > 0) {
                            let genre_string = genreDict.join()
                            url = url + "/genres/" + genre_string
                        }
                    }
                }

                if(criteria.selected_time_range && criteria.selected_time_range != undefined && criteria.selected_time_range != null) {
                    if(criteria.selected_time_range.id != undefined && criteria.selected_time_range.id != null) {
                        let time_id = criteria.selected_time_range.id
                        url = url + "/time/" + time_id
                        this.summary_time = time_id
                    }
                }
            }
            

            if(url.length == 0) {
                url = "/"
            }
            window.history.pushState({}, null, url)
            this.$router.push(url)
            return url
            
        },

        setFormDataFromRoute() {
            // console.log("route params", this.$route.params)
            let route_params_set = false
            if(this.$route.params.cinema_name && this.$route.params.cinema_name != undefined && this.$route.params.cinema_name != null) {
                let cinema_slug = this.$route.params.cinema_name
                Promise.resolve(RegionService.getCinemaBySlug(cinema_slug)).then((cinema) => {
                    if(cinema != undefined && cinema != null) {
                        this.form_data.selected_cinema = cinema
                        route_params_set = true
                    }
                });
            }

            // console.log(this.$route.params.cinema_type)
            if(this.$route.params.cinema_type && this.$route.params.cinema_type != undefined && this.$route.params.cinema_type != null) {
                let route_types = this.$route.params.cinema_type.split(",")

                if(this.type_groups && this.type_groups != undefined && this.type_groups != null) {
                    let type_groups = this.type_groups

                    let selected_types = []

                    for(let tg in type_groups) {
                        if(type_groups[tg] != undefined && type_groups[tg] != null) {
                            for(let rt in route_types) {
                                if(route_types[rt] && route_types[rt] != undefined && route_types[rt] != null) {
                                    if(route_types[rt] == type_groups[tg].name) {
                                        selected_types.push(type_groups[tg])
                                    }
                                }
                            }
                        }
                    }
                    if(selected_types.length > 0) {
                        this.form_data.cinema_types = selected_types
                    }
                }
            }

            if(this.$route.params.genres && this.$route.params.genres != undefined && this.$route.params.genres != null) {
                let route_genres = this.$route.params.genres.split(",")

                if(this.movieMeta && this.movieMeta != undefined && this.movieMeta != null) {
                    if(this.movieMeta.genres && this.movieMeta.genres != undefined && this.movieMeta.genres != null) {
                        let genres = this.movieMeta.genres
                        let selected_genres = []

                        for(let g in genres) {
                            if(genres[g] != undefined && genres[g] != null) {
                                for(let rg in route_genres) {
                                    if(route_genres[rg] != undefined && route_genres[rg] != null) {
                                        if(route_genres[rg] == genres[g].name) {
                                            selected_genres.push(genres[g])
                                        }
                                    }
                                }
                            }
                        }

                        if(selected_genres.length > 0) {
                            this.form_data.genres = selected_genres
                        }
                    }
                }
            }

            if(this.$route.params.time_range && this.$route.params.time_range != undefined && this.$route.params.time_range != null) {
                let route_time = this.$route.params.time_range
                let selected_time = null

                if(this.timeRangeData && this.timeRangeData != undefined && this.timeRangeData != null) {
                    if(this.timeRangeData.items && this.timeRangeData.items != undefined && this.timeRangeData.items != null) {
                        let ranges = this.timeRangeData.items

                        for(let r in ranges) {
                            if(ranges[r] != undefined && ranges[r] != null) {
                                if(ranges[r].id == route_time) {
                                    selected_time = ranges[r]
                                }
                            }
                        }

                        if(selected_time != null && selected_time != undefined) {
                            this.form_data.selected_time_range = selected_time
                        }
                    }
                }
            }

            return route_params_set
        },

        doLoadMoreNowShowing(totalLength) {
            // this.showLoadMoreNowShowing = false;
            this.loadMoreLimitNowShowing = this.loadMoreLimitNowShowing + this.loadMoreIncrement;

            if (this.loadMoreLimitNowShowing >= totalLength) {
                this.showLoadMoreNowShowing = false
            }
        },

        doLoadMoreComingSoon(totalLength) {
            this.showLoadMoreComingSoon = false;
            this.loadMoreLimitComingSoon = this.loadMoreLimitComingSoon + this.loadMoreIncrement;

            if (this.loadMoreLimitComingSoon >= totalLength) {
                this.showLoadMoreComingSoon = false
            }
        },

        doDataLayerImpressions(movie, position) {
            EcomTrackingService.doDataLayerImpressionsOnScroll(movie, position);
        },

        setGoogleAdPosition(scrollPos) {
            if(!this.$refs.googleAdLeft || !this.$refs.googleAdRight) return

            var headerHeight = 80
            var padding = 20
            let carouselHeight = this.$refs.featureCarousel ? this.$refs.featureCarousel.$el.offsetHeight : 0
            let leftAd = this.$refs.googleAdLeft.$el
            let rightAd = this.$refs.googleAdRight.$el

            let top = Math.max(scrollPos + headerHeight + padding, carouselHeight + headerHeight)
            leftAd.setAttribute('style', `left: -${leftAd.offsetWidth + 20}px; top: ${top}px`)
            rightAd.setAttribute('style', `right: -${rightAd.offsetWidth + 20}px; top: ${top}px`)
        },

        onPageScrolled(scrollPos, direction) {
            this.setGoogleAdPosition(scrollPos)
        },

        onResize(e) {
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset)
        },

        setCinemaOptions(cinemasByRegion) {
            this.cinemasByRegion = cinemasByRegion
        },

        setCinemaTypeOptions(CinemaTypeOptions) {
            this.cinemaTypes = CinemaTypeOptions
        },

        setFilterOptions(filterOptions) {
            this.filterOptions = filterOptions
        },

        setCinemasNearby(cinemasNearby) {
            this.cinemasNearby = cinemasNearby
            this.setCinemasByRegion(this.regions, this.result_cinemas)
        },

        summaryOptions(summary_data) {
            this.summary_data = summary_data
            this.summary_types = summary_data.types
            this.summary_time = summary_data.time
            if(this.form_data.selected_cinema) {
                this.summary_cinema_slug = this.form_data.selected_cinema.slug
            }
        },

        setLoading(loading) {
            this.loading = loading
        },

        setCinemaTypeGroups(cinemaTypeGroups) {
            this.cinemaTypeGroups = cinemaTypeGroups
        }
    },

    computed: {
        expireDate() {
            return localStorage.getItem('skclubAlert') ? localStorage.getItem('skclubAlert') : null
        },

        isNouveau() {

            // if(this.$route.path.includes('/type') && this.$route.path.includes("Nouveau")) {
            //     if(this.type_groups != undefined && this.type_groups != undefined) {
            //         if(this.type_groups.length > 0) {
            //             for(let g in this.type_groups) {
            //                 if(this.type_groups[g].name == "Nouveau") {
            //                     if(this.form_data.cinema_types != null && this.form_data.cinema_types != undefined && this.form_data.cinema_types.length > 0) {
            //                         for(let t in this.form_data.cinema_types) {
            //                             let exists = false

            //                             if(this.form_data.cinema_types[t].name == this.type_groups[g].name) {
            //                                 exists = true
            //                             }

            //                             if(!exists) {
            //                                 this.form_data.cinema_types.push(this.type_groups[g])
            //                             }
            //                         }
            //                     } else {
            //                         this.form_data.cinema_types.push(this.type_groups[g])
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // } else {
            //     // if(this.form_data.cinema_types.length > 0) {
            //     //     let cinema_types = []
            //     //     for(let t in this.form_data.cinema_types) {
            //     //         if(this.form_data.cinema_types[t].name != "Nouveau") {
            //     //             cinema_types.push(this.form_data.cinema_types[t])
            //     //         }
            //     //     }

            //     //     this.form_data.cinema_types = cinema_types
            //     // }
            // }

            if(this.form_data.cinemas_types != undefined && this.form_data.cinema_types != null) {
                if(this.form_data.cinema_types.length == 1) {
                    if(this.form_data.cinema_types[0].name == "Nouveau") {
                        // console.log("yup")
                        this.$root.$el.classList.add('nouveau')
                        // this.logoSrc = '/static/img/nouveau-logo.png'
                        return true
                    } else {
                        this.$root.$el.classList.remove('nouveau')
                    }
                } else {
                    this.$root.$el.classList.remove('nouveau')
                }
            } else {
                this.$root.$el.classList.remove('nouveau')
            }
            let isNouveau = this.$route.path.includes('type') && this.$route.path.includes('Nouveau');
            return isNouveau
        },

        googleAdType() {
            return this.isNouveau ? 'nouveau' : 'classic'
        }
    },

    created() {
        this.previewMode = PreviewService.hasPreviewContent()

        if(this.isNouveau) {
            this.onNouveau = true
            // console.log("onNouveau", this.onNouveau)
        }
        // console.log("home js")

        OrderService.tearDown();

        Promise.all([MovieService.getMovies((this.$route.query.noCache || false)), MovieMetaService.getFeaturedContent((this.$route.query.noCache || false)), RegionService.getRegions(), MovieService.generateTimeRanges(), MovieMetaService.getMovieMeta()]).then(([movies, featured, regions, time_ranges, meta])=> {
            this.featuredData = PreviewService.addPreviewToContentArrayIfAvailable('featured_content',featured);
            let now = new Date().getTime();

            this.currentTimeStamp = (now / 1000);

            Promise.resolve(AuthService.user()).then((user) => {
                this.user = user
            })            

            this.regions = regions.data
            if(regions.data != undefined && regions.data != null) {
                this.setCinemasByRegion(this.regions);
            }

            this.timeRangeData = time_ranges
            this.setTimeOptions(null)
            this.movieMeta = meta
            if(meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                Promise.all([this.setTypeOptions(meta.experiences), this.setGenreOptions(meta.genres)]).then(([types, genres]) => {
                    Promise.resolve(this.setFormDataFromRoute()).then((route_params) => {

                    })
                })
            }

            this.loading = false;

            this.movies = movies.byRelease();
            for(let ns in this.movies.now_showing) {
                if(this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && (typeof this.movies.now_showing[ns] == "object")) {
                    this.countNS++
                }
            }

            for(let ns in this.movies.coming_soon) {
                if(this.movies.coming_soon[ns] != null && this.movies.coming_soon[ns] != undefined && (typeof this.movies.coming_soon[ns] == "object")) {
                    this.countCS++
                }
            }
            // this.moviesData = this.movies
            this.predictiveText = movies.getNames();
            
            this.tabNowShowing = true
            this.tabComingSoon = false
            this.availableCinemas = movies.getCinemaIds()

            // this.loading = false;
            if(this.user != null && this.user != undefined) {
                if(this.user.MemberLevelId != undefined) {
                    if (!this.$breakpoints.xs && this.user.MemberLevelId == '19') {
                        let todaysDate = moment().format('YYYYMMDD')
                        if (this.expireDate == null) {
                            document.addEventListener('scroll', this.showAlerts, false)
                        } else if (moment(todaysDate).isAfter(this.expireDate)) {
                            localStorage.removeItem('skclubAlert')
                            document.addEventListener('scroll', this.showAlerts, false)
                        } else {
                            document.removeEventListener('scroll', this.showAlerts)
                        }
                    }
                }
            }

            Vue.nextTick(() => this.setGoogleAdPosition(window.scrollY || window.pageYOffset))
        });
        if (this.$route.path.includes('/type') && this.$route.path.includes("Nouveau") || this.isNouveau) {
            this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema'
            this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!'
            this.metaImage = '/static/img/nouveau-logo.png'
        } else {
            this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings'
            this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!'
            this.metaImage = '/static/img/sk-logo.png'
        }
        this.schemaDataSrc = {
            '@context' : 'http://schema.org',
            '@type' : 'Organization',
            'name' : 'Ster-Kinekor',
            'logo' : 'https://www.sterkinekor.com/​static/img/sk-logo.png',
            'url' : "https://www.sterkinekor.com",
            'sameAs' : [ '​https://twitter.com/sterkinekor',
                '​https://www.facebook.com/sterkinekortheatres',
                '​https://www.instagram.com/sterkinekor/',
                '​https://www.youtube.com/user/SterKinekorTheatres']
        }

    },

    beforeDestroy() {
        document.removeEventListener('scroll', this.showAlerts)
        window.removeEventListener('resize', this.onResize)
    },


    mounted() {
        if (window.__PRERENDER_INJECTED) {
            this.loading = false
            this.prerender = true

            if(window.__PRERENDER_INJECTED.movies) {
                let injected_movies = MovieService.setPreRenderMovies(window.__PRERENDER_INJECTED.movies)
                let movies = injected_movies
                this.injected_movies = injected_movies.byRelease()
                this.movies = injected_movies.byRelease()

                for(let ns in this.movies.now_showing) {
                    if(this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && (typeof this.movies.now_showing[ns] == "object")) {
                        this.countNS++
                    }
                }

                for(let ns in this.movies.coming_soon) {
                    if(this.movies.coming_soon[ns] != null && this.movies.coming_soon[ns] != undefined && (typeof this.movies.coming_soon[ns] == "object")) {
                        this.countCS++
                    }
                }
            } else {
                injected_movies = undefined
                this.injected_movies = injected_movies
            }

            if(window.__PRERENDER_INJECTED.regions) {
                let injected_regions = RegionService.setPreRenderRegions(window.__PRERENDER_INJECTED.regions)
                this.injected_regions = injected_regions
                this.regions = injected_regions.data
                if(this.regions != undefined && this.regions != null) {
                    this.setCinemasByRegion(this.regions);
                }
            } else {
                injected_regions = undefined
            }

            if(window.__PRERENDER_INJECTED.cinemas) {
                let injected_cinemas = RegionService.setPreRenderRegionsDictionary(window.__PRERENDER_INJECTED.cinemas)
                this.injected_cinemas = window.__PRERENDER_INJECTED.cinemas
            } else {
                injected_cinemas = undefined
            }

            if(window.__PRERENDER_INJECTED.meta) {
                let injected_meta = MovieMetaService.setPreRenderMovieMeta(window.__PRERENDER_INJECTED.meta)
                this.injected_meta = injected_meta
                
                let meta = injected_meta
                let featured = meta.featured_content
                this.featuredData = featured

                this.timeRangeData = time_ranges
                this.setTimeOptions(null)
                this.movieMeta = meta

                if(meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                    if(this.setTypeOptions(meta.experiences) && this.setGenreOptions(meta.genres)) {
                        this.setFormDataFromRoute()
                    }
                }

            } else {
                injected_meta = undefined
                this.injected_meta = undefined
                let featured = undefined
            }

            
            //let featured = MovieMetaService.getFeaturedContent((this.$route.query.noCache || false))
            // let regions = injected_regions
            let time_ranges = MovieService.generateTimeRanges()
            // let meta = injected_meta
            

            //Promise.all([MovieService.getMovies((this.$route.query.noCache || false)), MovieMetaService.getFeaturedContent((this.$route.query.noCache || false)), RegionService.getRegions(), MovieService.generateTimeRanges(), MovieMetaService.getMovieMeta()]).then(([movies, featured, regions, time_ranges, meta])=> {
                // this.featuredData = PreviewService.addPreviewToContentArrayIfAvailable('featured_content',featured);
                // let now = new Date().getTime();

                this.currentTimeStamp = (now / 1000);

                // Promise.resolve(AuthService.user()).then((user) => {
                //     this.user = user
                // })            

                // this.regions = regions.data
                // if(regions.data != undefined && regions.data != null) {
                //     this.setCinemasByRegion(this.regions);
                // }

                // this.timeRangeData = time_ranges
                // this.setTimeOptions(null)
                // this.movieMeta = meta
                // if(meta != undefined && meta != null && meta.experiences != undefined && meta.experiences != null && meta.genres != undefined && meta.genres != null) {
                //     Promise.all([this.setTypeOptions(meta.experiences), this.setGenreOptions(meta.genres)]).then(([types, genres]) => {
                //         Promise.resolve(this.setFormDataFromRoute()).then((route_params) => {

                //         })
                //     })
                // }

                //this.loading = false;

                // this.movies = movies.byRelease();
                // for(let ns in this.movies.now_showing) {
                //     if(this.movies.now_showing[ns] != null && this.movies.now_showing[ns] != undefined && (typeof this.movies.now_showing[ns] == "object")) {
                //         this.countNS++
                //     }
                // }

                // for(let ns in this.movies.coming_soon) {
                //     if(this.movies.coming_soon[ns] != null && this.movies.coming_soon[ns] != undefined && (typeof this.movies.coming_soon[ns] == "object")) {
                //         this.countCS++
                //     }
                // }
                // this.moviesData = this.movies
                this.predictiveText = movies.getNames();
                
                this.tabNowShowing = true
                this.tabComingSoon = false
                this.availableCinemas = movies.getCinemaIds()
            //
        }
        objectFitImages(document.querySelector('img.obejct-fit-polyfill'))

        // window.scroll({top: 0, left: 0});

        Vue.nextTick(() => this.setGoogleAdPosition(window.scrollY || window.pageYOffset))
        this.scrollSpy = new Utils.ScrollSpy(window, this.onPageScrolled)
        window.addEventListener('resize', this.onResize)
    },

    watch: {
        '$route'(to, from) {
            if(this.$route.path.includes("/type") && this.$route.path.includes("Nouveau")) {
                this.metaTitle = 'Cinema Nouveau Movies | Dedicated Art Cinema'
                this.metaDescription = 'Nouveau is a division of Ster-Kinekor Theatres and holds the prestige of being one of the world’s only dedicated "art cinema" chains, screening independent, alternative and art cinema content from cultures across the globe. Book your tickets today!'
                this.metaImage = '/static/img/nouveau-logo.png'
            } else {
                this.metaTitle = 'Cinema | Movie Showtimes and Online Movie Ticket Bookings'
                this.metaDescription = 'South Africa\'s biggest movie exhibitor. Browse the latest movies, trailers and showtimes. Book your movie tickets online today!'
                this.metaImage = '/static/img/sk-logo.png'
            }
            this.$emit('updateHead');
            this.setGoogleAdPosition(window.scrollY || window.pageYOffset)
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/pages/home/home.js